import { createBrowserRouter } from 'react-router-dom'
import { RouteError } from 'components/RouteError'
import { TermsAndConditions } from 'pages/TermsAndConditions'
import { AccountInfo } from 'pages/AccountInfo'
import { TermsAndConditionsViewer } from 'pages/TermsAndConditions/term-and-conditions-viewer'
import { InstantPayments } from 'pages/InstantPayments'
import { GaDebitCard } from 'pages/GaDebitCard'
import { TermsGlobalAccount } from 'pages/TermsGlobalAccount'
import { TermsGlobalAccountViewer } from 'pages/TermsGlobalAccount/terms-global-account-viewer'
import { TermsAndConditionsList } from 'pages/TermsAndConditionsList'
import { EditAlias } from 'pages/EditAlias'
import { FakeDoor } from 'pages/FakeDoor'

const routes = [
  {
    path: 'account-info',
    element: <AccountInfo />,
  },
  {
    path: 'terms-and-conditions-list',
    element: <TermsAndConditionsList />,
  },
  {
    path: 'terms-and-conditions-list/:id',
    element: <TermsAndConditionsList />,
  },
  {
    path: 'terms-and-conditions',
    element: <TermsAndConditions />,
  },
  {
    path: 'terms-and-conditions-view-document/:id',
    element: <TermsAndConditionsViewer />,
  },
  {
    path: 'instant-payments',
    element: <InstantPayments />,
  },
  {
    path: 'ga-debit-card',
    element: <GaDebitCard />,
  },
  {
    path: 'terms-global-account',
    element: <TermsGlobalAccount />,
  },
  {
    path: 'terms-global-account-view-document/:id/:isWebview',
    element: <TermsGlobalAccountViewer />,
  },
  {
    path: 'edit-alias',
    element: <EditAlias />,
  },
  {
    path: 'fakedoor',
    element: <FakeDoor />,
  },
  {
    path: '*',
    element: <RouteError />,
  },
]

export const router = createBrowserRouter(
  routes.map((route) => ({ ...route, errorElement: <RouteError /> })),
)
